export default __webpack_public_path__ + "static/media/p200-tip-box-open.0c96867d.svg";